import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import {
    CustomListDetail,
    RemoveCustomListItemsRequest,
} from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const removeCustomListItems = createAsyncThunk<
    CustomListDetail,
    RemoveCustomListItemsRequest,
    ThunkConfig<string | string[]>
>('customList/removeCustomListItems', async ({ listId, itemIds }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.delete<CustomListDetail>(
            `/v1/custom-lists/${listId}/items`,
            { data: { itemIds } },
        );

        return response.data;
    } catch (e) {
        return rejectWithValue(getApiErrorMessage(e));
    }
});
